import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { useStaticQuery, graphql } from 'gatsby';

import Fab from '@material-ui/core/Fab';
import AlarmOnOutlinedIcon from '@material-ui/icons/AlarmOnOutlined';
import PartyList from '../ContentsComponent/PartyList';
import SlideShow from './SlideShow';
import BorderColorIcon from '@material-ui/icons/BorderColor';

const PostWrapper = styled.div`
  width:90vw;
  position:relative;
  left:10%;
  transform: translateX(-20%);
  
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 4rem 2rem 1rem 2rem;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    margin: 4rem 1rem 1rem 1rem;
  }
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    margin: 4rem 1rem 1rem 1rem;
  }
`;

const TitleBox = styled.div`
    padding:20px;
       h4 {
           margin-top:0;
           margin-bottom:20px;
       }
       h5 {
           color:red;
           text-decoration:underline;
       }
       h3 {
         color:#ffab00;
       }
`;

const RecentEventSection = styled.section`
width:80%;
max-width:100%;
background-color:#f0fafe;
display:block;
padding-bottom:10px;

@media (max-width:${props => props.theme.breakpoints.md}) {
    width:100%;
}
@media (min-width:${props => props.theme.breakpoints.sm}) { 
    display:inline-block;
}
`;



const RecentEvent = ({ isphone }) => {
    const data = useStaticQuery(graphql`
          query {
            allContentfulFood(limit: 3){
              edges{
                node{
                    id
                  Name
                  path
                  price
                  release
                  tags{
                    tag
                  }
                  text {
                    json
                  }
                  mainpic{
                    fluid(maxWidth:1000,quality:90){
                      ...GatsbyContentfulFluid
                    }
                    title
                  }
                }
              }
              totalCount
            }
          }`)

  const { edges } = data.allContentfulFood;

    return(
        <RecentEventSection>
        <TitleBox>
            <h3><BorderColorIcon style={{color:"#ffb300"}} />&nbsp;&nbsp;最近火的料理</h3>
        {isphone ? 
        <SlideShow />
        :
        <PostWrapper>
        {edges.map(({ node },index) => {
          const { id, Name, path,price,release,tags,text,mainpic,totalCount } = node;
          return(
            <PartyList
              id={`$food-{id}`}
              cover={mainpic.fluid}
              path={path}
              title={Name}
              excerpt={text.json}
              tags={tags}
              price={price}
            />
          );
        })}
        </PostWrapper>
        }
        <Fab　id="category" variant="extended" style={{backgroundColor:"#ff9800"}} color="primary" href="/food"><AlarmOnOutlinedIcon />&nbsp;看更多</Fab>
        </TitleBox>
        </RecentEventSection>
    )
}

export default RecentEvent;

// RecentEvent.propTypes = {
//   isphone : PropTypes.bool.isRequired,
// }；